// @flow
import client from '../../client'
import format from '../../utils/format'

// API Endpoints
export const PAYPAL_ACCOUNT_ENDPOINT = '/travel_agent/paypal_account/{0}/'

/**
 * Deletes a paypal account
 * @param {Object} data Bank account information
 * @param {number} data.account_id Bank account ID
 * @return {Promise|Error} A resolved Promise Rejected with an Error
 */
export const deletePaypalAccount = (data: {
  account_id: number,
}): Promise<any> => {
  const { account_id } = data
  const endpoint = format(PAYPAL_ACCOUNT_ENDPOINT, account_id)

  return client.delete(endpoint).then(() => true)
}

export default deletePaypalAccount
